import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RangoPeriodo } from "src/app/dashboard/shared/dashboard-graficas";
import { Graficas } from "src/app/graficas/gestionGraficas/graficas.model";
import { sinSelloDeError } from "src/app/shared/http/sello-de-error";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";

/** Espejo de CosCore beans/iso42001/CorteRecienteBean. */
export interface CorteReciente {
  /** "Riesgo" (Plan Gestion RSK) o "Activo" (activos IA). */
  tipo?: string;
  consecutivo?: string;
  idMatriz?: number;
  matriz?: string;
  fecha?: Date | string;
  /** Ya recortado por el backend. */
  resultado?: string;
  /** true = corte migrado sin resultado; se pinta "Pendiente". */
  pendiente?: boolean;
  usuario?: string;
}

/** Espejo de CosCore beans/iso42001/RiesgosDashboardBean. */
export interface RiesgosDashboard {
  fechaIni?: string;
  fechaFin?: string;
  riesgosActivos?: number;
  riesgosSinCorte?: number;
  /** valor1 = Aplicada | Por aplicar | Vencida. */
  accionesPorEstado?: Graficas[];
  /** valor1 = "MM-yy". */
  cortesPorMes?: Graficas[];
  ultimosCortes?: CorteReciente[];
}

/** Lo que devuelve pendiente/consultar.do (MatrizPendienteRes); solo lo que usa la pestana. */
export interface PendientesRiesgos {
  pendientes?: Array<{ idPendiente?: number; entidad?: string; estatus?: string }>;
  aprobacionActiva?: boolean;
  /** Si puede aceptar y descartar: solo entonces la tarjeta lleva a la bandeja. */
  puedeEditar?: boolean;
  codigoError?: string;
  mensajeError?: string;
}

/**
 * Consultas propias de la pestana "Riesgos" del Dashboard de Inicio. Lo
 * que ya existe en el modulo (matrices, riesgos, activos) se pide con
 * MatrizRiesgoService; aqui solo va lo nuevo o lo que ese servicio no
 * expone.
 */
@Injectable({ providedIn: "root" })
export class RiesgosDashboardService {
  constructor(private http: HttpClient) {}

  /**
   * Resumen del periodo. El backend devuelve un bean, no un ConsultaList:
   * el error viene en los headers (SelloDeError) y aqui se vuelve error de
   * rxjs para que la pestana lo atienda como cualquier otro.
   */
  dashboard(rango: RangoPeriodo): Observable<RiesgosDashboard> {
    return this.http
      .post<RiesgosDashboard>(
        UrlConstantes.ISO42001_GR_DASHBOARD,
        { fechaIni: rango.inicio, fechaFin: rango.fin },
        { observe: "response" },
      )
      .pipe(sinSelloDeError("No se pudo consultar el resumen de riesgos."));
  }

  /** Propuestas del borrador de cambios; `pendientes` ya viene filtrado a PENDIENTE. */
  consultarPendientes(): Observable<PendientesRiesgos> {
    return this.http.post<PendientesRiesgos>(UrlConstantes.ISO42001_PEND_CONSULTAR, { limite: 1 });
  }
}
